/**
 * Where a time in lieu notification opens. HR's (a request, or an employee
 * ending their own agreement) open that person on the staff profile; the
 * employee's (approved, declined, ended by HR) open their own timesheet.
 * Shared by NotificationBell and usePushNotifications so the two agree.
 */
export function tilNotificationPath(type: string | undefined, data?: Record<string, string>): string | null {
  if (type === 'til_agreement_requested' || type === 'til_agreement_ended_by_employee') {
    return data?.userId ? `/hr/staff?tab=payroll&user=${data.userId}` : '/hr/staff?tab=payroll';
  }
  if (type === 'til_agreement_approved' || type === 'til_agreement_declined' || type === 'til_agreement_ended') {
    return '/timesheet/my-timesheet';
  }
  return null;
}
